import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastNotification = () => {
  return <Toaster />;
};

export default ToastNotification;
